import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslated, T } from '../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../Types';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { just } from 'maybeasy';
import IncludesFollowingContentIcon from './IncludesFollowingContentIcon';

interface Props {
  productLicense: ProductLicenseResource;
}

const IncludesFollowingContent: React.FC<Props> = ({ productLicense }) =>
  just({})
    .assign(
      'includesFollowingContentHeader',
      productLicense.payload.licenseTypeIncludesFollowingContentHeader,
    )
    .assign(
      'includesFollowingContentDesc',
      productLicense.payload.licenseTypeIncludesFollowingContentDesc,
    )
    .map(({ includesFollowingContentHeader, includesFollowingContentDesc }) => (
      <div className="mt-6">
        <h4 className="mb-3 text-sm font-semibold text-[#202532]">
          <T kind="Includes following content" />
        </h4>
        <div className="mt-6 flex">
          <IncludesFollowingContentIcon productLicense={productLicense} />
          <p className="text-sm font-medium">
            <AlreadyTranslated content={includesFollowingContentHeader} />
          </p>
        </div>
        <p className="mt-6 text-sm">
          <AlreadyTranslated content={includesFollowingContentDesc} />
        </p>
      </div>
    ))
    .getOrElse(emptyFragment);

export default observer(IncludesFollowingContent);
